export const TRAINING = {
  TITLE: 'Capacitación de Empleados',
  TRAINING_RESOURCES: {
    TITLE: 'Recursos',
    DESCRIPTION:
      'Accede al recurso a continuación para completar tu capacitación. ' +
      'Sigue las instrucciones proporcionadas para asegurar la finalización exitosa.',
    URLS: {
      WATCH: 'Ver video de capacitación',
    },
  },
  REPORTS: {
    TITLE: 'Informes',
    DESCRIPTION: 'Descarga los informes generados después de cada una de las sesiones de capacitación.',
    DOWNLOAD: {
      Last: 'Descargar último informe',
    },
  },
  DOCUMENTATION: {
    TITLE: 'Documentación',
    DESCRIPTION:
      'Accede a recursos para profundizar tu comprensión de la plataforma y ' +
      'aprende por qué la capacitación puede ser valiosa para tu organización.',
    URLS: {
      GUIDE: 'Documentación de Qalea',
    },
  },
  INSIGHTS: {
    TITLE: 'Insights',
    DESCRIPTION:
      'Obtén insights valiosos de tus sesiones y evaluaciones de capacitación.' +
      ' Revisa los resultados y descubre acciones recomendadas para fortalecer la seguridad de ' +
      'tu organización enfocándote en la capacitación y desarrollo de empleados.',
    TRENDS_NOT_YET_AVAILABLE: 'Sesiones de capacitación aún no iniciadas',
  },
}
